import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/app/[locale]/branchen/industries-overview.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8def95401ce4598/node_modules/next/dist/client/link.js");
